<app-content-wrapper [title]="'nav.contact'">
    <section class="contact-page">
        <div class="contact-info d-flex align-items-center">
            <h2>{{ config.contact.google.display }}</h2>
            <p class="address">
                <i class="bi bi-geo-alt-fill" aria-hidden="true"></i>
                <span class="text-wrap-pre">{{ config.contact.address.display }}</span>
            </p>

            <div class="socials gap-4 d-flex justify-content-center"  aria-label="Contact channels">
                <a class="social-btn" [href]="config.contact.phone.url" aria-label="Phone">
                    <i class="bi bi-telephone-fill" aria-hidden="true"></i>
                    <span class="label">{{ config.contact.phone.display }}</span>
                </a>

                <a class="social-btn" [href]="config.contact.google.url" target="_blank" rel="noreferrer" aria-label="Google Maps">
                    <i class="bi bi-google" aria-hidden="true"></i>
                    <span class="label">{{ config.contact.google.display }}</span>
                </a>

                <a class="social-btn" [href]="config.contact.instagram.url" target="_blank" rel="noreferrer" aria-label="Instagram">
                    <i class="bi bi-instagram" aria-hidden="true"></i>
                    <span class="label">{{ config.contact.instagram.display }}</span>
                </a>
            </div>
        </div>

        <div class="contact-map d-flex align-items-center">
            <app-loading-spinner [loading]="!mapLoaded">
                <iframe
                        title="Restaurant location map"
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                        [class.map-hidden]="!mapLoaded"
                        (load)="onMapFrameLoad()"
                        src="https://www.google.com/maps?q=Alfredo+dos+Frangos,+Guia,Albufeira&output=embed">
                </iframe>
            </app-loading-spinner>
        </div>
    </section>
</app-content-wrapper>
